"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getUrlParams(search) {
    const hashes = search.slice(search.indexOf('?') + 1).split('&');
    const params = {};
    hashes.forEach((hash) => {
        const [key, val] = hash.split('=');
        params[key] = decodeURIComponent(val);
    });
    return params;
}
const getOrganizacaoDaUrl = () => {
    const params = getUrlParams(window.location.search);
    if (Object.keys(params).includes('organizacao')) {
        const { organizacao } = params;
        return organizacao;
    }
    return '';
};
exports.default = getOrganizacaoDaUrl;
//# sourceMappingURL=queryParams.js.map